import { useGetChildrenSchedule } from '@repo/api/parent/useGetChildrenSchedule';
import { useGetMyChildren } from '@repo/api/parent/useGetMyChildren';
import { endOfWeek, startOfWeek } from 'date-fns';
import { useMemo } from 'react';

import { ChildSectionList } from '@/components/features/parent/ChildSectionList';
import ParentPageHeader from '@/components/features/parent/layout/ParentPageHeader';
import ScheduleTimetable, { getMeetingTimetableEntries } from '@/components/features/schedule/ScheduleTimetable';

export default function ParentSchedulePage() {
  const { data: children = [], isPending: isPendingChildren, isError, errorMessage } = useGetMyChildren();

  // The timetable lays out a Monday–Sunday week, so the request window is the
  // current week to match — same as the teacher and group views.
  const { after, before } = useMemo(() => {
    const now = new Date();
    return {
      after: startOfWeek(now).toISOString(),
      before: endOfWeek(now).toISOString(),
    };
  }, []);

  const { results, failed, isPending } = useGetChildrenSchedule(children, { after, before, sortOrder: 'ASC' }, !isPendingChildren);

  return (
    <div className={'base-direction-col'}>
      <div className={'flex w-full grow flex-col gap-6'}>
        <ParentPageHeader title={'Plan zajęć'} />

        <ChildSectionList
          results={results}
          failed={failed}
          isPending={isPendingChildren || isPending}
          isError={isError}
          errorMessage={errorMessage}
          defaultExpanded={'all'}
          isEmpty={(meetings) => !getMeetingTimetableEntries(meetings).length}
          emptyMessage={'Brak zajęć w tym tygodniu'}
          summary={(meetings) => `Zajęć: ${getMeetingTimetableEntries(meetings).length}`}
        >
          {(meetings) => <ScheduleTimetable meetings={getMeetingTimetableEntries(meetings)} linkDays={false} />}
        </ChildSectionList>
      </div>
    </div>
  );
}
